import React from 'react';

// The blog footer was removed — it linked to placeholder pages/categories that
// don't exist. Rendering nothing keeps the existing <Footer /> usages harmless.
const Footer = () => null;

export default Footer;
